import { render } from "./AllPets.vue?vue&type=template&id=e1e7aeb6"
import script from "./AllPets.vue?vue&type=script&lang=js"
export * from "./AllPets.vue?vue&type=script&lang=js"
script.render = render

export default script